<template>
    <div>
      <div style="margin: 10px 0">
        <el-input style="width: 200px;" type="text" v-model="name" placeholder="请输入公司名称" suffix-icon="el-icon-search"></el-input>
        <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>

        <el-button style="float:right; margin-left: 10px" type="danger" @click = "deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button>
        <el-button style="float:right;" type="primary" @click = "handAdd" icon="el-icon-circle-plus-outline">新增</el-button>
      </div>
      <!-- eslint-disable-next-line -->
      <el-table :data="tableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100">
        </el-table-column>
        <el-table-column prop="name" label="公司名称" width="200">
        </el-table-column>
        <el-table-column prop="address" label="公司地址">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime ? new Date(scope.row.createTime).toLocaleString() : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.updateTime ? new Date(scope.row.updateTime).toLocaleString() : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <!-- scope 拿到数据-->
            <el-button type="success" @click = "handEdit(scope.row)" style="margin-right: 5px">编辑<i class="el-icon-edit"></i></el-button>
            <el-popover
            placement="top"
            width="160"
            trigger="click">
            <p>您确定要删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible=false">取消</el-button>
              <el-button type="primary" size="mini" @click=handdele(scope.row.id)>确定</el-button>
            </div>
              <el-button type="danger" slot="reference">删除</el-button>
            </el-popover>

          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="公司信息" :visible.sync="dialogFormVisible" width="40%" >
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="公司名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="公司地址">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">确定</el-button>
            <el-button @click ='shutDown'>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    </template>
    
    <script>
    export default {
      name: "Company",
      data () {
        return{
          tableData: [],
          name: '',
          pageNum: 1,
          pageSize: 10,
          total: 0,
          dialogFormVisible: false,
          form: {},
          multipleSelection: {},
          headerBg: 'headerBg',
          data: {},
          visible: true,
          user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
          companies: [],
          comid: null,
          options1:[]
        }
      },
      mounted () {
        // 检查权限：只有超级管理员可以访问公司管理
        if (this.user.role !== '超级管理员') {
          this.$message.error('无权限访问公司管理功能')
          this.$router.push('/backhome')
          return
        }

        //请求分页查询
        this.load()
      },
      methods: {
        load () {//点击页码进行get请求
          this.request.get('/api/companies/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              name: this.name
            }
          }).then(res => {
            console.log('API响应:', res)
            if (res && res.data) {
              this.tableData = res.data.records || []
              this.total = res.data.total || 0
            } else {
              this.tableData = []
              this.total = 0
            }
          }).catch(error => {
            console.error('API调用失败:', error)
            this.tableData = []
            this.total = 0
            if (error.response && error.response.status === 403) {
              this.$message.error('无权限访问公司管理功能')
              this.$router.push('/backhome')
            }
          })
        },
        save () { // 新增或更新
          this.request.post('/api/companies/', this.form).then(res => {
            if (res && res.code === "200") {
              this.$message.success('保存成功')
              this.dialogFormVisible = false
              this.load()
            } else {
              this.$message.error('保存失败')
            }
          }).catch(error => {
            console.error('保存出错:', error)
            this.$message.error('保存失败，请重试')
            if (error.response && error.response.status === 403) {
              this.$message.error('无权限操作公司数据')
              this.$router.push('/backhome')
            }
          })
        },
        handAdd () {
          this.dialogFormVisible = true //打开表单
          this.form = {}
        },
        handEdit (row) { //把row里的数据传给表单
          this.form = JSON.parse(JSON.stringify(row)) // 深拷贝
          this.dialogFormVisible = true
        },
        handdele (id) { //通过id删除
          this.request.delete('/companies/' + id).then(res => {
            if (res && res.code === "200") {
              this.$message.success('删除成功')
              this.load()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }).catch(error => {
            console.error('删除出错:', error)
            this.$message.error('删除失败，请重试')
            if (error.response && error.response.status === 403) {
              this.$message.error('无权限删除公司数据')
              this.$router.push('/backhome')
            }
          })
        },
        handleSelectionChange (val) {
          console.log(val)
          this.multipleSelection = val
        },
        deleteBatch () {
          if (this.multipleSelection.length === 0) {
            this.$message.warning('请选择要删除的公司')
            return
          }

          // eslint-disable-next-line
          let ids = this.multipleSelection.map(val => val.id)
          this.request.delete('/api/companies/del/batch', { data: ids }).then(res => {
            if (res && res.code === "200") {
              this.$message.success('批量删除成功')
              this.load()
            } else {
              this.$message.error(res.message || '批量删除失败')
            }
          }).catch(error => {
            console.error('批量删除出错:', error)
            this.$message.error('批量删除失败，请重试')
            if (error.response && error.response.status === 403) {
              this.$message.error('无权限批量删除公司数据')
              this.$router.push('/backhome')
            }
          })
        },
        shutDown () {
          this.dialogFormVisible = false
        },
        handleSizeChange (pageSize) {
          this.pageSize = pageSize
          this.load()
        },
        handleCurrentChange (pageNum) {
          this.pageNum = pageNum
          this.load()
        }
      }
    }
    </script>
    
    <style scoped>
    
    </style>
    